const defaultTheme = {
  palette: {
    white: "hsl(0 0% 100%)",
    black: "hsl(0 0% 10%)",
    midnight: "hsl(215 71% 7%)",
    pearl: "hsl(210 40% 98%)",
    cloud: "hsl(210 33% 95%)",
    primary: {
      100: "hsl(203 100% 93%)",
      200: "hsl(208 85% 64%)",
      300: "hsl(208 90% 44%)",
      400: "hsl(208 91% 40%)",
      500: "hsl(208 90% 19%)",
      contrast: "hsl(0 80% 100%)"
    },
    secondary: {
      100: "hsl(49 98% 81%)",
      200: "hsl(49 98% 67%)",
      300: "hsl(49 98% 53%)",
      400: "hsl(49 86% 37%)",
      500: "hsl(49 87% 21%)",
      contrast: "hsl(180 4% 5%)"
    },
    neutral: {
      100: "hsl(0 0% 96%)",
      200: "hsl(208 15% 91%)",
      300: "hsl(208 40% 94%)",
      400: "hsl(208 32% 89%)",
      500: "hsl(208 26% 78%)",
      600: "hsl(208 22% 74%)",
      700: "hsl(208 18% 65%)",
      800: "hsl(209 13% 45%)",
      900: "hsl(208 15% 26%)"
    },
    success: {
      100: "hsl(129 40% 90%)",
      200: "hsl(131 39% 65%)",
      300: "hsl(131 39% 33%)",
      400: "hsl(131 39% 30%)",
      500: "hsl(131 39% 26%)"
    },
    error: {
      100: "hsl(0 53% 87%)",
      200: "hsl(0 54% 57%)",
      300: "hsl(0 87% 38%)",
      400: "hsl(0 88% 26%)",
      500: "hsl(0 87% 15%)"
    },
    warning: {
      100: "hsl(41 100% 90%)",
      200: "hsl(41 100% 65%)",
      300: "hsl(41 100% 50%)",
      400: "hsl(41 100% 35%)",
      500: "hsl(41 100% 20%)"
    },
    marketingLilac: {
      100: "hsl(252 79% 96%)",
      200: "hsl(254 78% 91%)",
      300: "hsl(253 79% 85%)",
      400: "hsl(253 30% 59%)",
      500: "hsl(253 33% 33%)"
    },
    marketingDarkBlue: {
      100: "hsl(222 26% 85%)",
      200: "hsl(221 30% 48%)",
      300: "hsl(221 80% 25%)",
      400: "hsl(221 80% 18%)",
      500: "hsl(221 80% 10%)"
    },
    marketingAqua: {
      100: "hsl(191 68% 94%)",
      200: "hsl(192 68% 79%)",
      300: "hsl(192 68% 70%)",
      400: "hsl(192 29% 49%)",
      500: "hsl(191 30% 28%)"
    },
    marketingTeal: {
      100: "hsl(176 66% 85%)",
      200: "hsl(176 66% 70%)",
      300: "hsl(176 67% 49%)",
      400: "hsl(176 40% 48%)",
      500: "hsl(177 89% 28%)"
    },
    complementaryLime: {
      100: "hsl(61 67% 88%)",
      200: "hsl(61 67% 58%)",
      300: "hsl(61 99% 40%)",
      400: "hsl(61 99% 28%)",
      500: "hsl(61 100% 16%)"
    },
    complementaryPaleOrange: {
      100: "hsl(25 94% 93%)",
      200: "hsl(25 94% 75%)",
      300: "hsl(24 93% 65%)",
      400: "hsl(24 51% 45%)",
      500: "hsl(25 52% 26%)"
    },
    complementaryHibiscus: {
      100: "hsl(333 49% 89%)",
      200: "hsl(334 50% 62%)",
      300: "hsl(334 59% 46%)",
      400: "hsl(334 59% 32%)",
      500: "hsl(334 60% 18%)"
    },
    complementaryCrimson: {
      100: "hsl(2 77% 91%)",
      200: "hsl(1 78% 70%)",
      300: "hsl(1 77% 57%)",
      400: "hsl(1 59% 40%)",
      500: "hsl(1 59% 23%)"
    },
    ctaColor: "hsl(49 100% 63%)",
    ctaContrastColor: "hsl(0 0% 0%)"
  },
  fontFamily: {
    sans: "Manrope, Roboto, sans-serif"
  },
  header: {
    logoHeight: "1.25rem",
    height: "auto",
    bg: "hsl(0 0% 100%)",
    border: "hsl(208 15% 91%)",
    createAccountBtn: {
      bg: "hsl(208 90% 44%)",
      text: "hsl(0 80% 100%)",
      hover: {
        bg: "hsl(208 91% 34%)",
        text: "hsl(0 80% 100%)"
      }
    },
    signInBtn: {
      bg: "hsl(0 0% 0% / 0%)",
      text: "hsl(208 90% 44%)",
      hover: {
        bg: "hsl(208 85% 79%)",
        text: "hsl(208 91% 48%)"
      }
    },
    generalBtn: {
      bg: "hsl(0 0% 0% / 0%)",
      text: "hsl(0 0% 0%)",
      hover: {
        bg: "hsl(0 0% 96%)",
        text: "hsl(0 0% 0%)"
      }
    }
  }
};
const camelToKebabCase = (key) => key.replace(/([\da-z])([A-Z])/g, "$1-$2").toLowerCase();
const toThemeVars = (theme) => {
  const themeVariables = {};
  const generateCssVariables = (partialTheme, path = []) => {
    for (const key in partialTheme) {
      const value = partialTheme[key];
      const transformedKey = camelToKebabCase(key);
      const newPath = [...path, transformedKey];
      if (typeof value === "string") {
        themeVariables[`--mz-${newPath.join("-")}`] = value.replace("hsl(", "").replace(")", "");
      } else {
        generateCssVariables(value, newPath);
      }
    }
  };
  generateCssVariables(theme);
  return themeVariables;
};
const extendTheme = (partialTheme) => {
  const theme = deepMerge(defaultTheme, partialTheme);
  return theme;
};
const extendPalette = (partialPalette) => {
  const palette = deepMerge(defaultTheme.palette, partialPalette);
  return palette;
};
const deepMerge = (target, source) => {
  const recursiveMerge = (target2, source1, source2) => {
    for (const key in source1) {
      const targetValue = target2[key] ?? {};
      const source1Value = source1[key];
      const source2Value = source2?.[key];
      if (Object.prototype.toString.call(source1Value) === "[object Object]" || Array.isArray(source1Value)) {
        target2[key] = recursiveMerge(
          targetValue,
          source1Value,
          source2Value
        );
      } else {
        target2[key] = source2Value ?? source1Value;
      }
    }
    return target2;
  };
  return recursiveMerge({}, target, source);
};

export { defaultTheme, extendPalette, extendTheme, toThemeVars };
